// WhatsApp utility functions for generating contact links

/**
 * Generate a WhatsApp link with pre-filled message
 * @param {string} phoneNumber - Phone number (with country code, e.g., +221771234567)
 * @param {string} message - Pre-filled message
 * @returns {string} WhatsApp URL
 */
export function getWhatsAppLink(phoneNumber, message = '') {
  // Clean phone number (remove spaces, dashes, etc.)
  const cleanNumber = phoneNumber.replace(/[\s\-\(\)]/g, '').replace(/^\+/, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodedMessage}` : ''}`;
}

/**
 * Generate absence notification message
 */
export function getAbsenceMessage(studentName, date, parentName) {
  return `Bonjour ${parentName},

Nous vous informons que votre enfant ${studentName} a été absent(e) le ${date}.

Merci de nous communiquer le motif de cette absence.

Cordialement,
L'Administration CARFEIS`;
}

/**
 * Generate payment reminder message
 */
export function getPaymentReminderMessage(studentName, amount, dueDate, parentName) {
  return `Bonjour ${parentName},

Nous vous rappelons qu'un paiement de ${amount} FCFA pour ${studentName} est en attente.
Date d'échéance : ${dueDate}

Merci de régulariser votre situation.

Cordialement,
L'Administration CARFEIS`;
}

/**
 * Generate grade notification message
 */
export function getGradeMessage(studentName, subject, grade, parentName) {
  return `Bonjour ${parentName},

Nous vous informons que ${studentName} a obtenu la note de ${grade}/20 en ${subject}.

Cordialement,
L'Administration CARFEIS`;
}

/**
 * Generate general notification message
 */
export function getGeneralMessage(studentName, content, parentName) {
  return `Bonjour ${parentName},

Concernant votre enfant ${studentName} :

${content}

Cordialement,
L'Administration CARFEIS`;
}

/**
 * Generate meeting invitation message
 */
export function getMeetingMessage(studentName, date, time, reason, parentName) {
  return `Bonjour ${parentName},

Nous souhaitons vous rencontrer concernant ${studentName}.

📅 Date : ${date}
🕐 Heure : ${time}
📌 Motif : ${reason}

Merci de confirmer votre disponibilité.

Cordialement,
L'Administration CARFEIS`;
}

/**
 * Open WhatsApp with pre-filled message
 */
export function openWhatsApp(phoneNumber, message = '') {
  const url = getWhatsAppLink(phoneNumber, message);
  window.open(url, '_blank');
}
